/**
 * Task Projects API Service
 *
 * CRUD operations for task projects (institutional tenants).
 * Distinct from contractors projects - these are for task organization.
 */

import axios from 'axios';
import type { TaskProject } from '@/types/tasks';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('ngui_auth_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface CreateProjectRequest {
  name: string;
  description?: string;
  color?: string;
  icon?: string;
}

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  color?: string;
  icon?: string;
}

export const taskProjectsApi = {
  list: async (archived = false): Promise<TaskProject[]> => {
    const response = await apiClient.get('/task-projects', { params: { archived } });
    return response.data;
  },

  create: async (data: CreateProjectRequest): Promise<TaskProject> => {
    const response = await apiClient.post('/task-projects', data);
    return response.data;
  },

  update: async (id: string, data: UpdateProjectRequest): Promise<TaskProject> => {
    const response = await apiClient.put(`/task-projects/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/task-projects/${id}`);
  },
};
